
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import SearchResult from './searchResult.vue';
import DocButton from '@/components/ui/buttons/DocButton.vue';
import { fetchSearchRequest } from '@/api';
import { GlobalBusNames } from '@/templates/DataNames';
import GlobalBus from '@/plugins/GlobalBus';
import { currentInstance, debounce } from '@/heplers';
import { State } from 'vuex-class';
import { getCookieValue } from '@/store/profile/actions';
import { filterContentFromSearch } from '@/heplers/filterContentByCountry';
import { getUserCountryCode } from '@/heplers/getUserCountryCode';

@Component({
  components: {
    SearchResult,
    DocButton,
  },
})
export default class Search extends Vue {
  @State rootNames: any;
  public searchInputValue = '';
  public isOpenSearch = false;
  public isClosing = false;
  isKit: boolean = currentInstance === 'kit';
  public inputSearchDebounced = debounce(() => {
    this.searchRequest();
  }, 200);

  $refs!: {
    searchInput: HTMLElement;
  };

  get searchInput() {
    return this.searchInputValue;
  }

  set searchInput(value) {
    this.searchInputValue = value;
    if (value.length === 0)
      GlobalBus.emit(GlobalBusNames.SEARCHRESULT, {
        inputString: '',
        searchResults: {},
      });
  }

  @Watch('$route')
  onRouteChange() {
    this.searchInput = '';
  }

  submitSearch() {
    if (!this.searchInput.length) return;

    let url = currentInstance === 'vox' ? '/docs/search?q=' : '/kit/docs/search?q=';

    this.$router.push(url + this.searchInput).catch((error) => error);
  }

  beforeMount() {
    this.$off('close_search');
  }

  mounted() {
    this.$on('close_search', () => (this.isOpenSearch = false));
  }

  collapseSearch(bool: boolean, fromClose = false) {
    if (fromClose) {
      this.isClosing = true;
      // Хз почему 500, мне показалось это наиболее оптимальным временем для того чтобы юзер оценил крутую анимацию и одновременно не взбесился что долго закрывается
      setTimeout(() => {
        this.isClosing = false;
        this.isOpenSearch = bool;
      }, 500);
    } else {
      this.isOpenSearch = bool;
    }

    if (this.isOpenSearch)
      this.$nextTick(() => {
        this.$refs.searchInput.focus();
        //@ts-expect-error: Property 'select' does not exist on type 'HTMLElement'. Did you mean 'onselect'
        this.$refs.searchInput.select();
      });
  }

  sendGtmSearch(_query: string) {
    this.$sendGtmEvent({
      event: 'vox_docs_search',
      category: 'search',
      action: 'enter',
      label: this.searchInput + this.$router.currentRoute.path,
    });
  }

  async searchRequest() {
    if (!this.searchInput.length) return;

    let searchSort = '';

    if (!this.isKit) {
      const searchKey = Object.keys(this.rootNames).filter((fqdn) =>
        this.$route.meta.fqdn.includes(fqdn)
      )[0];
      searchSort = searchKey?.length ? `&sort=${searchKey}` : '';
    }

    const langRu = [process.env.VUE_APP_LANG, process.env.VUE_APP_PROD_LANG].includes('ru');
    const queryLang = langRu && this.isKit ? '&lang=ru' : '';
    const withByLink = getCookieValue('with_by_link');
    const withByLinkQuery = withByLink ? `&with_by_link=${withByLink}` : '';
    const searchString = `searchDoc?q=${this.searchInput.trim()}${searchSort}${queryLang}${withByLinkQuery}`;

    const response = await fetchSearchRequest(searchString);

    const countryCode = await getUserCountryCode(null);

    this.sendGtmSearch(this.searchInput);
    GlobalBus.emit(GlobalBusNames.SEARCHRESULT, {
      inputString: this.searchInput,
      searchResults: response ? filterContentFromSearch(response.data, countryCode) : {},
    });
  }
}
